import { createAsyncThunk, current } from '@reduxjs/toolkit';
import axios from 'axios';
import { axiosCustom } from '../../../utils/axiosUser';

export const initStateGameUserList = {
  gameUserList: { data: null, loading: false, error: null },
};

export const gameUserList = createAsyncThunk('user/gameUserList', async (data, { rejectWithValue, fulfillWithValue }) => {
  return await axiosCustom
    .get(`/game/user/list`)
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerGameUserList = {
  [gameUserList.pending]: (state) => {
    state.gameUserList.loading = true;
  },
  [gameUserList.fulfilled]: (state, action) => {
    state.gameUserList.loading = false;
    state.gameUserList.data = action.payload;
    state.gameUserList.error = null;
  },
  [gameUserList.rejected]: (state, action) => {
    state.gameUserList.loading = false;
    state.gameUserList.error = action.payload;
  },
};
